export const retrieveDisclaimer = (disclaimer) => {
    let disclaimerArray;
    const result = { title: '', items: [], paragraph: '' };
    /* The disclaimer section is a single string that may consist of 3 parts.
    * Title, items and paragraph. */
    if (disclaimer) {
        if (disclaimer.includes('<br>- ')) {
            disclaimerArray = disclaimer?.split('<br>- ');
            if (disclaimerArray[0]) {
                result.title = disclaimerArray[0];
            }
            const lastIndex = disclaimerArray.length - 1;
            for (let index = 1; index < disclaimerArray.length; index++) {
                /* If the last element has a br/ tag, break it down into a separate sub-paragraph
                * And re-insert the first part of the last element as part of the items array.
                * At the time of writing this comment, only ING displays this last paragraph. */
                if (index === lastIndex && disclaimerArray[lastIndex].includes('<br/>')) {
                    const lastParagraph = disclaimerArray[lastIndex].split('<br/>');
                    result.paragraph = lastParagraph[1];
                    disclaimerArray[lastIndex] = lastParagraph[0];
                }
                const element = disclaimerArray[index];
                result.items.push(element.replace('<br>', ''));
            }
        } else if (disclaimer.includes('<br/>')) {
            disclaimerArray = disclaimer?.split('<br/>');
            if (disclaimerArray[0]) {
                result.title = disclaimerArray[0];
            }
            for (let index = 1; index < disclaimerArray.length; index++) {
                const element = disclaimerArray[index];
                if (element !== '') result.items.push(element.replace('<br/>', ''));
            }
        } else if (disclaimer.includes('<li>')) {
            disclaimerArray = disclaimer?.split('<ul>');
            if (disclaimerArray[0]) {
                result.title = disclaimerArray[0];
            }
            if (typeof document !== 'undefined') {
                const e = document.createElement('div');
                e.innerHTML = disclaimer;
                const list = Array.from(e.getElementsByTagName('li'));

                list.forEach((element) => {
                    result.items.push(element.innerText);
                });
            }
        }
    }
    return result;
};
